import { useEffect } from "react";
import { QueryClient } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { rootComponentsStore } from "../../../hookstate/rootComponentsStore";
import { setFunnelModalConfig } from "../../funnel/FunnelModal";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import {
  useStripeCheckoutReturn,
  useStripeCheckoutReturnPollingTimeoutToast,
} from "./useStripeCheckoutReturn";
import { refreshHydratedAccount } from "./refreshHydratedAccount";
import {
  clearPendingDonationConfirmation,
  restorePendingDonationConfirmation,
} from "./stripePaymentReturn";

type UseRootStripeCheckoutReturnsOptions = {
  queryClient: QueryClient;
};

export function useRootStripeCheckoutReturns({
  queryClient,
}: UseRootStripeCheckoutReturnsOptions) {
  const [searchParams] = useSearchParams();
  const onPollingTimeout = useStripeCheckoutReturnPollingTimeoutToast();

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    if (searchParams.get("stripe_flow") || searchParams.get("stripe_result")) {
      return;
    }

    if (
      rootComponentsStore.funnelModal.type.get({ noproxy: true }) ===
      FUNNEL_TYPES.donateConfirmation
    ) {
      clearPendingDonationConfirmation();
      return;
    }

    restorePendingDonationConfirmation();
  }, [searchParams]);

  useStripeCheckoutReturn({
    expectedFlow: "portal",
    onSuccessReturn: async () => {
      setFunnelModalConfig();
      await refreshHydratedAccount(queryClient);
    },
    onPollingTimeout,
  });
}
